export enum UserTagManagerEventsQueryKeys {
  Primary = '/user-tag-manager-events/me',
}
